import { ORDER_FULFILLMENT_STATUSES } from '../../../../../services/exports/Constants';

export default {
  title: 'Forventet {{orderMethod}}: {{day}} omkring kl. {{time}}',
  status: {
    [ORDER_FULFILLMENT_STATUSES.REJECTED]: {
      title: 'Ordre afvist',
    },
    [ORDER_FULFILLMENT_STATUSES.CREATED]: {
      title: 'Ordre modtaget',
    },
    [ORDER_FULFILLMENT_STATUSES.REVIEWED]: {
      title: 'Din ordre er set',
    },
    [ORDER_FULFILLMENT_STATUSES.ACCEPTED]: {
      title: 'Ordre bekræftet',
    },
    [ORDER_FULFILLMENT_STATUSES.READY]: {
      title: 'Ordren er klar',
    },
    [ORDER_FULFILLMENT_STATUSES.ON_DELIVERY]: {
      title: 'Ordren bliver leveret',
    },
    [ORDER_FULFILLMENT_STATUSES.PICKED]: {
      title: 'Ordren er gennemført',
    },
  },
  labels: {
    today: 'I dag',
  },
  waiting_confirmation: {
    title: 'Afventer ordrebekræftelse',
    description: 'Et øjeblik...',
  },
  pickup_time: {
    title: 'Afhentningstidspunkt',
    description: 'Bekræftet af {{name}}',
  },
  delivery_time: {
    title: 'Leveringstidspunkt',
    description: 'Bekræftet af {{name}}',
  },
  warning_label: {
    pickup_time_changed: '{{company}} har ændret tidspunktet fra {{initialTime}} til {{currentTime}}',
  },
};
